import React from 'react';
import cloudinaryVideoUrl, { DEVICE_TYPE } from '@scentregroup/ui/tools/cloudinary/video';
import { jsx as _jsx } from "react/jsx-runtime";
export const Video = _ref => {
  let {
    url,
    wide
  } = _ref;
  const deviceType = wide === true ? DEVICE_TYPE.wide : DEVICE_TYPE.square;
  const source = cloudinaryVideoUrl({
    contentfulUrl: url,
    removeAudio: true,
    deviceType
  });
  return /*#__PURE__*/_jsx("video", {
    playsInline: true,
    autoPlay: true,
    loop: true,
    muted: true,
    controls: false,
    "data-id": "video_index_Video_video",
    children: /*#__PURE__*/_jsx("source", {
      type: "video/mp4",
      src: source,
      "data-id": "video_index_Video_video_source"
    })
  });
};